export function buildUrl(baseUrl, params) {
    const queryString = Object.keys(params)
        .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
        .map(key => {
            if (Array.isArray(params[key])) {
                return params[key].map(value => `${encodeURIComponent(key)}[]=${encodeURIComponent(value)}`).join('&');
            }
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        })
        .join('&');

    return `${baseUrl}?${queryString}`;
}
